import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import Modal from "react-modal";
import moment from "moment";

const AgentCallForm = (props) => {
  const [date, setDate] = useState(moment().format("YYYY-MM-DD")); // Default to today's date
  const [farmerId, setFarmerId] = useState("");
  const [farmerData, setFarmerData] = useState([]);
  const [fieldExecutiveName, setFieldExecutiveName] = useState("");
  const [outstandingLoan, setOutstandingLoan] = useState(0);
  const [clientStatus, setClientStatus] = useState("");
  const [response, setResponse] = useState("Positive");
  const [paidAmount, setPaidAmount] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const { sendRequest: getFarmerData } = useHttp();

  const { sendRequest: getLoanData } = useHttp();

  const getFarmerDetail = () => {
    getFarmerData(
      {
        url: "/api/getfarmerDetail/",
      },
      (res) => {
        if (res) {
          setFarmerData(res.output);
        }
      }
    );
  };

  useEffect(() => {
    getFarmerDetail();
  }, [getFarmerData]);

  const onFarmerChange = (e) => {
    const selectedId = e.target.value || 0;
    setFarmerId(selectedId);

    const selectedFarmer = farmerData?.find(
      (farmer) => farmer.farmerId == selectedId
    );

    console.log(selectedFarmer);

    if (selectedFarmer && selectedFarmer.executiveName) {
      setFieldExecutiveName(selectedFarmer.executiveName);
    } else {
      setFieldExecutiveName("");
    }

    getLoanData(
      {
        url: `/api/fillFarmerLoanDetailList/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerId=${selectedId}`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setOutstandingLoan(res[0]?.totalBalanceAmount || "0");
          setBalanceAmount(res[0]?.totalBalanceAmount || "0");
        }
      }
    );
  };

  useEffect(() => {
    setBalanceAmount((outstandingLoan - paidAmount).toFixed(2));
  }, [response]);

  const onPaidAmountChange = (e) => {
    const paid = e.target.value;
    if (paid > outstandingLoan) {
      toast.error("Paid amount cannot exceed the outstanding loan amount.");
      return;
    }
  
    setPaidAmount(paid);
    setBalanceAmount((outstandingLoan - paid).toFixed(2));
  };

  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);

    return uniqueID.toString();
  }

  const { sendRequest: postAgentCall } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = [
      {
        agentCallServiceId: props.update
          ? props.update.agentCallServiceId
          : generateUniqueID(),
        agentCallServiceDate: moment(date).format("DD/MM/YYYY"),
        farmerId: farmerId,
        outstandingLoan: parseFloat(outstandingLoan),
        clientReachedUnreached: clientStatus,
        response: response,
        paidAmount: parseFloat(paidAmount),
        balanceAmount: parseFloat(balanceAmount),
        remarkNote: remarks,
        orgId: parseInt(localStorage.getItem("orgId")),
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        entryTime: moment().format("HH:mm:ss"),
        entryLatLong,
      },
    ];

    // console.log(data);

    postAgentCall(
      {
        url: "/api/agentCallService/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);

        toast.success(
          `Agent Call Details ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      getLoanData(
        {
          url: `/api/fillFarmerLoanDetailList/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerId=${props.update.farmerId}`,
        },
        (res) => {
          if (res) {
         //   console.log(res);
            let loanAmt = res[0]?.totalBalanceAmount || 0;

            const pAmt = props.update.paidAmount || 0;

            loanAmt = loanAmt + pAmt;
            setOutstandingLoan(loanAmt);

          //  console.log(loanAmt);
            let balAmt = loanAmt - pAmt;
            setBalanceAmount(balAmt);
          }
        }
      );
      setDate(
        moment(props.update.agentCallServiceDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        )
      );

      setFarmerId(props.update.farmerId);
      setFieldExecutiveName(props.update.employeeName);
      // const loanAmt=
      //setOutstandingLoan(props.update.outstandingLoan);
      setClientStatus(props.update.clientReachedUnreached);
      setResponse(props.update.response);
      setPaidAmount(props.update.paidAmount);

      setRemarks(props.update.remarkNote);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* Card */}
              <div className="card card-default">
                {/* Header */}
                <div className="card-header">
                  <h3 className="card-title">Agent Daily Call Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* Body */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      {/* Date Field */}
                      <div className="form-group">
                        <label htmlFor="date">Date</label>
                        <input
                          type="date"
                          className="form-control"
                          id="date"
                          value={date}
                          required
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="response">Farmer Name</label>
                        <select
                          id="farmerId"
                          className="form-control"
                          value={farmerId}
                          onChange={onFarmerChange}
                          required
                        >
                          <option value="">Select</option>
                          {farmerData &&
                            farmerData.map((farmer) => (
                              <option
                                key={farmer.farmerId}
                                value={farmer.farmerId}
                              >
                                {farmer.farmerName} {}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="fieldExecutiveName">
                          Field Executive Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="fieldExecutiveName"
                          value={fieldExecutiveName}
                          readOnly
                          onChange={(e) =>
                            setFieldExecutiveName(e.target.value)
                          }
                          placeholder="Field Executive Name"
                        />
                      </div>
                    </div>
                    {/* Outstanding Loan */}
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Outstanding Loan</label>
                        <input
                          className="form-control"
                          type="number"
                          value={outstandingLoan || 0}
                          placeholder="Outstanding Loan"
                          readOnly
                        />
                      </div>
                    </div>{" "}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="clientStatus">
                          Client Reached/Unreached
                        </label>
                        <select
                          className="form-control"
                          id="clientStatus"
                          value={clientStatus}
                          required
                          onChange={(e) => {
                            setClientStatus(e.target.value);
                            setPaidAmount(0);
                            setResponse("");
                          }}
                        >
                          <option value="">Select</option>
                          <option value="reached">reached</option>
                          <option value="unreached">unreached</option>
                        </select>
                      </div>
                    </div>
                    {clientStatus === "reached" && (
                      <>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="response">Response</label>
                            <select
                              className="form-control"
                              id="response"
                              required
                              value={response}
                              onChange={(e) => {
                                setResponse(e.target.value);
                                setPaidAmount(0);
                              }}
                            >
                              <option value="">Select</option>

                              <option value="Immediate Payment">
                                Immediate Payment
                              </option>
                              <option value="Pledges">Pledges</option>
                              <option value="Indecisive">Indecisive</option>
                              <option value="Non-Cooperative">
                                Non-Cooperative
                              </option>
                            </select>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row">
                    {clientStatus === "reached" &&
                      response === "Immediate Payment" && (
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="paidAmount">Paid Amount</label>
                            <input
                              type="number"
                              required
                              className="form-control"
                              id="paidAmount"
                              max={outstandingLoan}
                              value={paidAmount}
                              onChange={onPaidAmountChange}
                              placeholder="Enter Paid Amount"
                            />
                          </div>
                        </div>
                      )}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Balance Amount</label>
                        <input
                          type="number"
                          className="form-control"
                          value={balanceAmount}
                          readOnly
                          placeholder="Balance Amount"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="remarks">Remark/Note</label>
                        <input
                          className="form-control"
                          id="remarks"
                          placeholder="Enter remarks/note"
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default AgentCallForm;
